import { call } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* setSourceRepeatMode(action) {
  const { mode, sourceId } = action.data;
  yield call(
    putAndWait,
    getInDomain('playback.actions.repeatSource')({
      sourceId,
      mode,
    }),
  );
}
